function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0c57ff;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 618.9,
  y1: 324.01,
  x2: 1082.21,
  y2: 0.01,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#17c917"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.23,
  stopColor: "#14ac52"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.61,
  stopColor: "#107fae"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.87,
  stopColor: "#0d62e8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0c57ff"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M128.53,158.45V79.35H79.1V.25H0V207.88A128.66,128.66,0,0,0,128.53,336.42v-79.1A49.51,49.51,0,0,1,79.1,207.88V158.45Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M300.49,158.45V79.35H251.05V.25H172V207.88A128.66,128.66,0,0,0,300.49,336.42v-79.1a49.52,49.52,0,0,1-49.44-49.44V158.45Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M427.54,242.89A49.44,49.44,0,0,1,497.46,173l55.93-55.93a128.53,128.53,0,1,0,0,181.77l-55.93-55.93A49.52,49.52,0,0,1,427.54,242.89Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M1033.93,48.05V96.11H985.88V48.05Zm-48.05,96.11v-48H937.82V48.05h48.06V0H889.77a48.14,48.14,0,0,0-48.06,48.05V384.44a48.14,48.14,0,0,1,48.06-48.06h144.16V144.16ZM827.62,14.1a47.79,47.79,0,0,0-34-14.1H649.5V336.38H793.66a48.12,48.12,0,0,1,48.05,48.06V48.05A47.8,47.8,0,0,0,827.62,14.1ZM1033.93,0V48.05H1082V0ZM1082,48.05V96.11h48V48.05Zm-48.06,48.06v48.05H1082v-48Z"
})));

var SvgTtcLogo = function SvgTtcLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1130.04 384.44",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTtcLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ttc-logo.d1723706.svg";
export { ForwardRef as ReactComponent };